import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import {
    getCommerceSdkIdentity,
    TEQTANK_COMMERCE_SDK_VERSION,
    type Commerce,
} from "@teqtank/commerce-sdk";

@customElement("teqtank-sdk-status")
export class TeqtankSdkStatus extends LitElement {
    @property({ attribute: false })
    public accessor commerce: Commerce | undefined;

    public static override styles = css`
        :host {
            container-type: inline-size;
            display: block;
            font-family: Inter, ui-sans-serif, system-ui, sans-serif;
        }

        .status {
            border: 1px solid color-mix(in srgb, currentColor 16%, transparent);
            border-radius: 1rem;
            padding: 1.25rem;
            background: color-mix(in srgb, Canvas 96%, currentColor 4%);
            color: CanvasText;
        }

        .eyebrow {
            margin: 0 0 0.35rem;
            font-size: 0.75rem;
            font-weight: 700;
            letter-spacing: 0.08em;
            text-transform: uppercase;
            opacity: 0.65;
        }

        h1 {
            margin: 0;
            font-size: clamp(1.25rem, 4cqw, 1.75rem);
        }

        dl {
            display: grid;
            grid-template-columns: max-content 1fr;
            gap: 0.4rem 1rem;
            margin: 1rem 0 0;
        }

        dt {
            font-weight: 700;
        }

        dd {
            margin: 0;
            opacity: 0.75;
        }
    `;

    protected override render() {
        const identity = getCommerceSdkIdentity();
        const lifecycle = this.commerce?.lifecycle;

        return html`
            <section class="status" part="status">
                <p class="eyebrow">Iteration 009</p>
                <h1>${identity.name}</h1>

                <dl>
                    <dt>SDK</dt>
                    <dd>${this.commerce?.version ?? TEQTANK_COMMERCE_SDK_VERSION}</dd>

                    <dt>Contracts</dt>
                    <dd>${identity.contractVersion}</dd>

                    <dt>Commerce key</dt>
                    <dd>${this.commerce?.configuration.commerceKey ?? "Initializing"}</dd>

                    <dt>Session</dt>
                    <dd>
                        ${this.commerce?.session !== undefined ? "Established" : "Initializing"}
                    </dd>

                    <dt>Runtime</dt>
                    <dd>${lifecycle?.isReady === true ? "Ready" : "Initializing"}</dd>
                </dl>
            </section>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "teqtank-sdk-status": TeqtankSdkStatus;
    }
}
